<main class="md:h-full overflow-hidden relative" #mainContainer [class.iframe-mode]="iframeMode">

    <!-- TOP & BOTTOM GRADIENTS. Top: iframe mode only, in every view (non-iframe has the topbar instead).
         Bottom: always shown except on panos. -->
    <section class="absolute top-0 z-5 flex flex-col h-full w-full pointer-events-none" [class.hidden]="isFullscreen()">
        @if(iframeMode) {
        <div class="bg-linear-180 dark:from-black to-transparent h-20 w-full" [class]="{ 'from-white': isTopLevelView(), 'from-black': !isTopLevelView() }"></div>
        }
        <div class="bg-linear-0 dark:from-black to-transparent h-20 w-full mt-auto transition-opacity" [class]="{ 'from-white': isTopLevelView(), 'from-black': !isTopLevelView(), 'opacity-0': isPano() }"></div>
    </section>
    
    <!-- TOPBAR -->
    <div class="absolute z-10 w-full top-0 left-0 pointer-events-none">
        <app-topbar/>
    </div>

    <!-- NEIGHBORS OVERLAY (desktop, non-iframe only) -->
    @if(!iframeMode) {
        <div class="neighbors-overlay hidden md:flex absolute z-10 w-full justify-center pointer-events-none">
            <app-neighbors class="w-80 pointer-events-auto"/>
        </div>
    }

    <!-- MAP OVERLAY & FOOTER -->
    <section class="section-overlay absolute z-10 py-4 px-3.5 lg:px-[18px] lg:py-[24px] w-full flex flex-col justify-between pointer-events-none">

        <!-- MAP OVERLAY -->
        <app-overlay/>

        <!-- FOOTER -->
        <app-footer/>

    </section>

    <!-- CONTENT - VIEWERS -->
    <section class="w-full h-full bg-black">
        <ng-content/>
    </section>

    <!-- BOTTOM SHEET MOBILE  -->
    <div class="md:hidden overflow-hidden relative pointer-events-none">
        <app-bottom-sheet />
    </div>

    <!-- DYNAMIC CONTENT - PORTAL -->
    @if (portalContent()) {
        <section class="absolute z-20 w-full h-full top-0 left-0 pointer-events-auto">
            <ng-template [cdkPortalOutlet]="portalContent()!"/>
        </section>
    }

</main>